/* eslint max-params: ["error", 5] */

import './rga-tab.scss';
import React, {Component} from 'react';
import AdditionalData from './recalled-part-tab/components/additional-data';
import Analyst from './recalled-part-tab/components/analysis';
import AttachmentDetails from './recalled-part-tab/components/attachment-details';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import PropTypes from 'prop-types';
import RgaAdditionalDataInfo from '../../../rga-search-results/state/rga-additional-data-info';
import RgaDetails from '../../../rga-search-results/state/rga-details';
import RgaQuestionAns from './recalled-part-tab/components/rgaQuestionAnswer';
import RgaQuestionAnswer from '../../../rga-search-results/state/rga-question-answer';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import TabNavigation from '../../../../shared/components/tab-navigation';
import {getNavigationTabs} from '../../../shared/returned-part-navigation-helper';

class ReturnedPartInfoForm extends Component {

    componentWillMount() {

        if (this.props.queryParams && this.props.queryParams.tab !== 'attachment') {

            this.props.actions.setRouteToReturnPartDefaultTab();

        }

    }

    render() {

        return (
            <section className='rga-tab'>
                <div className='rga-analysis-tabs'>
                    <div className='rga-search-tabs'>
                        <TabNavigation
                            tabs={getNavigationTabs()}
                        />
                    </div>
                </div>
                {this.props.queryParams && this.props.queryParams.tab === 'analyst' &&
                <Analyst
                    actions={this.props.actions}
                    analysisStatus={this.props.analysisStatus}
                    busyCounter={this.props.busyCounter}
                    partReqStatus={this.props.partReqStatus}
                    rgaDetails={this.props.rgaDetails}
                    rgaUnits={this.props.rgaUnits}
                    security={this.props.security}
                />
                }
                {this.props.queryParams && this.props.queryParams.tab === 'additional-data' &&
                <AdditionalData
                    actions={this.props.actions}
                    additionalDataFlag={this.props.additionalDataFlag}
                    additionalDataInfo={this.props.additionalDataInfo}
                    additionalDataTest={this.props.additionalDataTest}
                    additionalDataType={this.props.additionalDataType}
                    busyCounter={this.props.busyCounter}
                    rgaDetails={this.props.rgaDetails}
                    rgaUnits={this.props.rgaUnits}
                    security={this.props.security}
                />
                }
                {this.props.queryParams && this.props.queryParams.tab === 'attachment' &&
                <AttachmentDetails
                    actions={this.props.actions}
                    busyCounter={this.props.busyCounter}
                    fileCollection={this.props.fileCollection}
                    rgaDetails={this.props.rgaDetails}
                    security={this.props.security}
                />
                }
                {this.props.queryParams && this.props.queryParams.tab === 'q-and-a' &&
                <RgaQuestionAns
                    actions={this.props.actions}
                    busyCounter={this.props.busyCounter}
                    rgaDetails={this.props.rgaDetails}
                    rgaQuestionAnswer={this.props.rgaQuestionAnswer}
                />
                }
            </section>
        );

    }
}

ReturnedPartInfoForm.displayName = 'ReturnedPartInfoForm';
ReturnedPartInfoForm.propTypes = {
    actions: PropTypes.object.isRequired,
    additionalDataFlag: PropTypes.bool.isRequired,
    additionalDataInfo: PropTypes.instanceOf(RgaAdditionalDataInfo).isRequired,
    additionalDataTest: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    additionalDataType: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    analysisStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    fileCollection: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
    partReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    queryParams: PropTypes.object.isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    rgaQuestionAnswer: PropTypes.arrayOf(PropTypes.instanceOf(RgaQuestionAnswer)).isRequired,
    rgaUnits: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default ReturnedPartInfoForm;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/returned-part-information/returned-part-info-form.js